import { render } from "./SectionComp.vue?vue&type=template&id=6477e849&scoped=true"
import script from "./SectionComp.vue?vue&type=script&lang=js"
export * from "./SectionComp.vue?vue&type=script&lang=js"

import "./SectionComp.vue?vue&type=style&index=0&id=6477e849&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6477e849"]])

export default __exports__